<!--
 * @Author       : panyangyang
 * @Date         : 2026-09-01 11:06:14
 * @LastEditTime : 2026-09-01 11:06:14
 * @LastEditors  : panyangyang
 * @Description  : 数字翻牌效果
 * @FilePath     : \ngs_platform_manage_admin\src\views\large-screen\components\digit-flip.vue
-->
<template>
	<div class="flip-card">
		<transition name="flip" mode="out-in">
			<div class="flip-number" :key="value">
				{{ value }}
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'DigitFlip',

	props: {
		value: {
			type: [String, Number],
			required: true
		}
	}
}
</script>

<style scoped>
.flip-card {
	position: relative;
	width: 40px;
	height: 58px;
	margin-right: 8px;
	overflow: hidden;

	border: 2px solid rgba(64, 181, 255, 0.75);
	border-radius: 2px;
	background: rgba(25, 97, 180, 0.35);

	perspective: 600px;
}

.flip-number {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	color: #ffb52a;
	font-size: 44px;
	line-height: 58px;
	backface-visibility: hidden;
}

/* 新数字翻入 */
.flip-enter-active {
	animation: flip-in 0.55s ease-out;
}

/* 旧数字翻出 */
.flip-leave-active {
	position: absolute;
	inset: 0;
	animation: flip-out 0.55s ease-in;
}

@keyframes flip-in {
	0% {
		opacity: 0;
		transform: rotateX(-90deg);
	}

	100% {
		opacity: 1;
		transform: rotateX(0);
	}
}

@keyframes flip-out {
	0% {
		opacity: 1;
		transform: rotateX(0);
	}

	100% {
		opacity: 0;
		transform: rotateX(90deg);
	}
}
</style>
